import { downloadFromBlobUrl } from "../../../../../common/utils/download_utils";
import { IDownloadAlvenariaEstruturaUseCase } from "../../../presentation/useCases/read/download_alvenaria_estrutura_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DownloadAlvenariaEstruturaUseCase
 */

export class DownloadAlvenariaEstruturaUseCase implements IDownloadAlvenariaEstruturaUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async downloadAlvenariaEstrutura(
    idAlvenariaObra: number,
    nroArquivo: number,
    nomeArquivo: string,
  ): Promise<void> {
    const result = await this.repository
      .downloadAlvenariaEstrutura(idAlvenariaObra, nroArquivo);
    await downloadFromBlobUrl(result, nomeArquivo);
  }
}
